import styled from 'styled-components';

import withParallax from 'utils/parallax';
import { media } from 'utils/detection';

export default styled(withParallax(styled.div`
  width: 100%;
  height: 2px;
  background-color: ${props => props.theme.textSemiDark};
`))`
  margin: 40px 0 75px 0;

  ${media.medium`
    margin: 3vw 0 7vw 0;
    max-width: 30vw;
  `}
`;
